import styled from 'styled-components'
import { InlineAuthor } from '../../../../../components/page/resources/formPage'

export const WebinarRecordingBodyContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  padding-top: 64px;
  padding-bottom: 96px;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    flex-direction: column;
    padding-top: 0px;

    .WebinarRecording__Body__left-container {
      order: 2;
    }
    .WebinarRecording__Body__right-container {
      order: 1;
      margin-bottom: 96px;
    }
  }

  .WebinarRecording__Body__left-container {
    width: 100%;
    max-width: 588px;
    height: 100%;
    flex: 1;
    margin-right: 126px;

    .WebinarRecording__Body {
      margin-bottom: 48px;
    }

    .WebinarRecording__fineprint {
      margin-top: 48px;
    }

    .WebinarRecording__Body ul {
      list-style: none;
    }

    .WebinarRecording__Body ul li:before {
      background-color: ${({ theme }) => theme.webMktNewPalette.orange[50]};
      border-radius: 50%;
      content: '';
      display: inline-block;
      margin-left: -20px;
      margin-right: 15px;
      margin-bottom: 2px;
      height: 6px;
      width: 6px;
    }
  }

  .WebinarRecording__Body__right-container {
    width: 100%;
    height: 100%;
    flex: 1;
    max-width: 488px;

    .WebinarRecording__Speakers-container {
      margin-bottom: 64px;
    }

    .WebinarRecording__FAQ-text {
      display: inline;
    }

    .CTA {
      font-weight: 400;
    }
  }
`

export const WebinarRecordingHeroContainer = styled.div`
  background-color: ${({ theme }) => theme.webMktNewPalette.deepBlue[70]};

  .heroInner h1 {
    padding-top: 48px;

    ${({ theme }) => theme.breakpoints.down('sm')} {
      padding-top: 24px;
    }
  }

  .Hero__Container {
    padding-left: 0;
  }

  .WebinarRecording__clock_date_Container {
    display: flex;
    padding-bottom: 48px;
    align-items: center;

    img {
      width: 22px;
      height: 22px;
      padding-right: 17px;
    }
  }

  .WebinarRecording__date {
    margin-bottom: 0px;
    color: ${({ theme }) => theme.webMktNewPalette.white};
    padding-right: 20px;
  }

  .heroInner {
    ${({ theme }) => theme.breakpoints.down('lg')} {
      padding: 0;
    }

    ${({ theme }) => theme.breakpoints.down('sm')} {
      padding: 0;
    }
  }
`

export const WebinarRecordingSpeakersContainer = styled.div`
  margin-bottom: 64px;

  .WebinarRecordingSpeakers__title {
    margin-bottom: 24px;
  }
`

export const WebinarRecordingInlineAuthor = styled(InlineAuthor)`
  .WebinarRecording__InlineAuthor__Byline {
    color: #273139;
  }
`
